import { render, staticRenderFns } from "./IgsToaster.vue?vue&type=template&id=c63147f8&scoped=true&"
import script from "./IgsToaster.vue?vue&type=script&lang=ts&"
export * from "./IgsToaster.vue?vue&type=script&lang=ts&"
import style0 from "./IgsToaster.vue?vue&type=style&index=0&id=c63147f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63147f8",
  null
  
)

export default component.exports